import { render } from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=template&id=20474b38&scoped=true&ts=true"
import script from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=script&lang=ts"
export * from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=script&lang=ts"

import "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=style&index=0&id=20474b38&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20474b38"]])

export default __exports__